// packages
import axios from "axios";
import TokenService from "./token.service";
import { BASE_URL } from "../config/siteUrls";
import { useHistory } from "react-router-dom";
import {
  setInToLocalStorage,
  removeFromLocalStorage,
} from "../utils/webStorage";

const instance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

function Logout() {
  const history = useHistory();
  removeFromLocalStorage("user");
  window.localStorage.clear();
  history.push("/login");
}

instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error?.config;
    if (originalConfig.url !== "/auth/signin" && error.response) {
      if (error?.response?.status === 403 && !originalConfig?.sent) {
        originalConfig.sent = true;
        //Perform the token refresh
        try {
          const rs = await axios.post(BASE_URL + "api/auth/refresh", {
            refreshToken: TokenService.getLocalRefreshToken(),
          });
          const { accessToken } = rs.data;
          originalConfig.headers["Authorization"] = `Bearer ${accessToken}`;
          setInToLocalStorage("user", JSON.stringify(rs.data));
          return instance(originalConfig);
        } catch (error) {
          return Promise.reject(error);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
